import CoreAxios from '@/services/axios'

class Api extends CoreAxios {
  constructor() {
    super({})
  }

  auth = {
    login: b => this.post('api/auth/dashboard/login', b),
  }

  reception = {
    findAll: ({ params } = { params: {} }) => this.get('dashboard/a/receptions', {
      params,
    }),
    findOne: ({ id }) => this.get(`dashboard/a/receptions/details/${id}`),
    create: b => this.post('api/reception/create', b),
  }

  order= {
    findAll: ({ params } = { params: {} }) => this.get('dashboard/a/orders', {
      params,
    }),
    findOne: ({ id }) => this.get(`dashboard/a/orders/details/${id}`),
    create: b => this.post('api/reception/create', b),
    changeStatus: ({ id, body }) => this.patch(`api/order/change-status/${id}`, body),
  }

  product = {
    findAll: ({ params } = { params: {} }) => this.get('dashboard/a/products', {
      params,
    }),
    findOne: ({ id }) => this.get(`dashboard/a/products/details/${id}`),
    create: b => this.post('api/product/create', b, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }),
    edit: ({ id, body }) => this.patch(`api/product/edit/${id}`, body),
  }

  warehouse = {
    findAll: ({ params } = { params: {} }) => this.get('dashboard/a/warehouses', {
      params,
    }),
    findOne: ({ id }) => this.get(`dashboard/a/warehouses/details/${id}`),
    create: b => this.post('api/warehouse/create', b),
    edit: ({ id, body }) => this.patch(`api/warehouse/edit/${id}`, body),
  }

  district = {
    findAll: ({ params } = { params: {} }) => this.get('dashboard/a/districts', {
      params,
    }),
    findOne: ({ id }) => this.get(`dashboard/a/districts/details/${id}`),
    create: b => this.post('api/district/create', b),
    edit: ({ id, body }) => this.patch(`api/district/edit/${id}`, body),
  }

  region= {
    findAll: ({ params } = { params: {} }) => this.get('dashboard/a/regions', {
      params,
    }),
    findOne: ({ id }) => this.get(`dashboard/a/regions/details/${id}`),
    create: b => this.post('api/region/create', b),
    edit: ({ id, body }) => this.patch(`api/region/edit/${id}`, body),
  }
}

export default new Api()
